import { ref } from 'vue';
import Cookies from 'js-cookie';
const CHECKOUT_SUBSCRIPTION_COOKIE_NAME = 'checkoutSubscription';
const subscribe = ref<boolean>(false);
export function useNewsletterSubscription() {
    const saveSubscriptionForRedirectData = () => {
        if (subscribe.value) {
            Cookies.set(CHECKOUT_SUBSCRIPTION_COOKIE_NAME, 'true');
        } else {
            removeSubscriptionForRedirectData();
        }
    };

    const getSubscriptionForRedirectData = (): boolean => {
        const cookie = Cookies.get(CHECKOUT_SUBSCRIPTION_COOKIE_NAME);
        return cookie !== undefined;
    };

    const removeSubscriptionForRedirectData = () => {
        Cookies.remove(CHECKOUT_SUBSCRIPTION_COOKIE_NAME);
    };
    return {
        subscribe,
        saveSubscriptionForRedirectData,
        getSubscriptionForRedirectData,
        removeSubscriptionForRedirectData,
    };
}
